import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=4f83938b&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=ts&"
export * from "./Content.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=4f83938b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83938b",
  null
  
)

export default component.exports